<template>
  <div
    v-if="isShow"
    id="company-ochart"
    :class="{ ochartposition: position, fullscreen: isFullScreen }"
    :style="`zIndex:${zIndex};height:${height}`"
  >
    <div :class="{ 'company-ochart-left': true, 'show-menu': showSearch, 'hide-menu': !showSearch }">
      <div class="control-btn" @click="changeMenuStatus">操作选项</div>

      <div class="structure-left flex-column">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="O-chart" name="O-chart">
            <el-table :data="companyFiles" size="mini" style="width: 100%" :max-height="fileTableHeight">
              <el-table-column label="文件名">
                <template slot-scope="scope">
                  <span class="a-link" @click="getFile(scope.row)">{{ scope.row.originalname }}</span>
                </template>
              </el-table-column>
              <el-table-column label="上传人">
                <template slot-scope="scope">
                  <span style="margin-right:10px">{{ scope.row.uploader && scope.row.uploader.toString() }}</span>
                </template>
              </el-table-column>
              <el-table-column label="上传时间">
                <template slot-scope="scope">
                  <span>{{ formatTime(scope.row.createdAt) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="a-link" @click="setAsStructure(scope.row)">{{
                    scope.row.组织结构 ? '组织结构' : '设置为组织结构'
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="搜索" name="搜索">
            <ul class="search-container">
              <li>
                <span class="label">部门：</span>
                <el-select v-model="search.部门" class="search" filterable size="mini">
                  <el-option value="高管"></el-option>
                  <el-option v-for="item in departments" :key="item" :value="item"></el-option>
                </el-select>
              </li>
              <li style="display:flex">
                <span class="label">姓名：</span>
                <el-input v-model.trim="search.姓名" class="search" size="mini"></el-input>
              </li>
              <li>
                <span class="label">职能模块：</span>
                <el-select v-model="search.职能模块" class="search" filterable multiple size="mini">
                  <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
                </el-select>
              </li>
              <li>
                <span class="label">人员变动：</span>
                <el-select v-model="search.status" class="search" filterable multiple size="mini">
                  <el-option v-for="item in status" :key="item.value" :value="item.value">
                    <span class="simi-icon"><i :class="item.class"></i>{{ item.value }}</span>
                  </el-option>
                </el-select>
              </li>
            </ul>
            <div class="text-right">
              <span class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="toSearch"
                >搜索</span
              >
              <span
                class="radish-btn radish-btn-primary radish-btn-small"
                style="margin-left: 10px;"
                @click="clearSearch"
                >清空</span
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="公司架构" name="公司架构">
            <div class="text-center">
              <el-popover placement="right" width="700" trigger="click">
                <div class="radish-btn radish-btn-primary radish-btn-small" @click="uploadAtta">上传ochart附件</div>
                <FileTable
                  :files="companyFiles"
                  :paginate="false"
                  width="600"
                  :show-download="isAdmin"
                  height="300"
                  :on-delete="deleteCompanyAtta"
                />
                <span
                  slot="reference"
                  class="radish-btn radish-btn-primary radish-btn-small uploadAtta"
                  style="margin-left: 10px;"
                  >ochart附件</span
                >
              </el-popover>
              <span
                class="radish-btn radish-btn-primary radish-btn-small"
                style="margin-left: 10px;"
                @click="toEditTheStructure"
                >编辑结构</span
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="操作" name="操作">
            <div class="text-center">
              <span class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="refresh"
                >刷新数据</span
              >
              <span
                class="radish-btn radish-btn-primary radish-btn-small"
                style="margin-left: 10px;"
                @click="displayingOchart = !displayingOchart"
              >
                {{ displayingOchart ? '隐藏ochart' : '显示ochart' }}
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>

        <Collapse
          v-if="activeTabName != 'O-chart'"
          class="flex-column section flex-left-space"
          style="overflow: hidden;"
          :fold="false"
        >
          <template slot="header">
            <h3>
              公司树状图
              <el-tooltip class="item" effect="dark" content="双击部门名称打开相应部门的人选列表" placement="top">
                <span class="icon">?</span>
              </el-tooltip>
            </h3>
          </template>
          <TreeOchart
            ref="TreeOchart"
            class="flex-left-space flex-column overflow-auto"
            :tree="tree"
            :nodes="nodes"
            @refresh="refresh"
            @showDepartmentList="showDepartmentList"
          ></TreeOchart>
        </Collapse>
      </div>
    </div>
    <div v-if="activeTabName == 'O-chart'" :class="{ 'company-ochart-right': true, 'show-menu': showSearch }">
      <div v-if="previewUrl" style="height:100%;position:relative;overflow:auto">
        <div v-show="isOfficeUrl" id="testIframeCompanyOchat" style="height:75vh !important"></div>
        <div v-viewer><img v-show="isImgUrl" :src="previewUrl" style="width:100%" /></div>
      </div>
      <div
        v-for="i in 12"
        :key="i"
        class="alpha-water-mark-one"
        :style="{ top: (Math.ceil(i / 3) - 1) * 200 + 'px', left: i % 3 == 1 ? '20%' : i % 3 == 2 ? '50%' : '80%' }"
      >
        {{ account }}
      </div>
    </div>
    <div v-show="activeTabName != 'O-chart'" :class="{ 'company-ochart-right': true, 'show-menu': showSearch }">
      <div class="above" :style="`height:${displayingOchart ? '30%' : '0%'}`">
        <companyOchartComponent
          ref="companyOchartComponent"
          :company-name="companyName"
          :department-name="departmentName"
          @getTree="getTree"
          @showDepartmentList="showDepartmentList"
        ></companyOchartComponent>
      </div>
      <div class="below" :style="`height:${displayingOchart ? '70%' : '100%'}`">
        <companyDepartmentList
          ref="companyDepartmentList"
          :company-name="companyName"
          :department-name="departmentName"
        ></companyDepartmentList>
      </div>
    </div>
    <!-- 编辑ochart结构 -->
    <companyStructure
      ref="companyStructure"
      style="width:100%;z-index: 31;position: absolute;"
      :company="company"
      :show-search="showSearch"
      :height="height"
      @updateTabName="updateTabName"
      @changeMenuStatus="changeMenuStatus"
    ></companyStructure>
    <!-- 情报 -->
    <Bulletin ref="Bulletin" :company-name="companyName" style="z-index: 30;"></Bulletin>

    <!-- 附件 -->
    <UploadDialog
      ref="UploadDialog"
      type="附件"
      label="公司O-Chart"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    />
  </div>
</template>
<script>
import Collapse from '../baseComponent/Collapse'
import companyOchartComponent from './companyOchartComponent'
import companyStructure from './companyStructure'
import companyDepartmentList from './companyDepartmentList.vue'
import Bulletin from '../component/Bulletin'
import TreeOchart from './TreeOchart'
import { FileTable } from '../../../file'
// import WPSOfficeSDK from '../../../assets/weboffice/web-office-sdk-v1.1.2.es'

const dateFormat = require('dateformat')

export default {
  components: {
    companyOchartComponent,
    companyDepartmentList,
    companyStructure,
    Bulletin,
    TreeOchart,
    Collapse,
    FileTable,
  },
  props: {
    company: { type: Object, default: () => ({}) },
    position: { type: Boolean, default: false },
    coulddrag: { type: Boolean, default: false },
    height: { type: String, default: '100%' },
    // isShow: { type: Boolean, defa1: false },
  },
  data() {
    return {
      isFullScreen: false,
      isLoading: false,
      zIndex: '',
      companyName: '',
      departmentName: '',
      isShow: false,
      search: {},
      status: [
        { value: '在职', class: 'el-icon-success icon-blue' },
        { value: '新入职', class: 'el-icon-warning icon-red' },
        { value: '离职', class: 'el-icon-error icon-grey' },
        { value: '未绑定', class: 'el-icon-question icon-lightred' },
      ],
      status2value: { 在职: 2, 新入职: 3, 离职: 4, 未绑定: 1 },
      departments: [],
      tree: [],
      showSearch: true,
      nodes: [],
      companyFiles: [],
      isAdmin: false,
      activeTabName: 'O-chart',
      displayingOchart: false,
      previewUrl: '',
      fileTableHeight: 600,
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          permissions: {
            chat: false,
            comment: false,
            copy: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: false,
            review: false,
            reviewGroups: null,
            commentGroups: {},
            userInfoGroups: null,
          },
          // url: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/test1.html',
          url:
            'https://alphahr.oss-cn-beijing.aliyuncs.com/public/d32bfbcd863860b41535f5fc1923396d.%E6%98%93%E7%A5%96%E6%B1%9F-%E7%A8%8E%E5%8A%A1%E8%B4%9F%E8%B4%A3%E4%BA%BA-%E4%B8%AD%E5%A4%96%E5%90%88%E8%90%A5%EF%BC%88%E5%90%88%E8%B5%84%C2%B7%E5%90%88%E4%BD%9C%EF%BC%89-%E7%94%B7-32%E5%B2%81-%E7%A1%95%E5%A3%AB-8%E5%B9%B4%E4%BB%A5%E4%B8%8A%E5%B7%A5%E4%BD%9C%E7%BB%8F%E9%AA%8C%E7%8C%8E%E8%81%98%E7%AE%80%E5%8E%86.docx',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: 'http://47.93.158.22:12002/example/track?filename=new.docx&useraddress=27.47.132.115',
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            comments: false,
            feedback: false,
            forcesave: false,
            submitForm: false,
            compactHeader: true,
            compactToolbar: true,
            hideRightMenu: true,
            hideRulers: true,
            toolbarNoTabs: true,
            // zoom: -1,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'view',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    categories() {
      return app.categories
    },
    isOfficeUrl() {
      const wordTypeReg = /(\.doc)|(\.docm)|(\.docx)|(\.docxf)|(\.dot)|(\.dotm)|(\.dotx)|(\.epub)|(\.fodt)|(\.fb2)|(\.htm)|(\.html)|(\.mht)|(\.odt)|(\.oform)|(\.ott)|(\.oxps)|(\.pdf)|(\.rtf)|(\.txt)|(\.djvu)|(\.xml)|(\.xps)/
      const excelTypeReg = /(\.csv)|(\.fods)|(\.ods)|(\.ots)|(\.xls)|(\.xlsb)|(\.xlsm)|(\.xlsx)|(\.xlt)|(\.xltm)|(\.xltx)/
      const pptTypeReg = /(.fodp)|(\.odp)|(\.otp)|(\.pot)|(\.potm)|(\.potx)|(\.pps)|(\.ppsm)|(\.ppsx)|(\.ppt)|(\.pptm)|(\.pptx)/
      return wordTypeReg.test(this.previewUrl) || excelTypeReg.test(this.previewUrl) || pptTypeReg.test(this.previewUrl)
    },
    isImgUrl() {
      return /(\.png)|(\.jpg)|(\.jpeg)/.test(this.previewUrl)
    },
    account() {
      return app.user.account
    },
  },
  watch: {
    $route(to, from) {
      this.close()
    },
    displayingOchart() {
      this.$nextTick(_ => {
        this.$refs.companyDepartmentList && this.$refs.companyDepartmentList.initComponentHeight()
      })
    },
    activeTabName(newValue, oldValue) {
      if (newValue === '公司架构') {
        this.toEditTheStructure()
      }
    },
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
  },
  methods: {
    async setAsStructure(file) {
      if (file.组织结构) return this.$message.warning('改文件为目前展示的组织结构')
      const res = await app.service('company').setCompanyStructureFile({ _id: file._id })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.$emit('fileChange')
        for (const v of this.companyFiles) {
          this.$set(v, '组织结构', v._id === file._id)
        }
      } else this.$message.error(res.msg)
    },
    formatTime(time) {
      if (!time) return ''
      return dateFormat(new Date(time), 'yyyy-mm-dd')
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
    async getFile({ md5, fileId, _id }) {
      if (!md5 && !fileId && !_id) return
      try {
        const query = md5 ? { md5 } : fileId || _id ? { _id: fileId || _id } : undefined
        const src = await window.app.service('file').buildPreview(query)
        const url = src.url
        if (window.location.origin.indexOf('https://') !== -1) {
          this.previewUrl = url.replace('http://', 'https://')
        } else if (window.location.origin.indexOf('http://') !== -1) {
          this.previewUrl = url.replace('https://', 'http://')
        }
        this.documentType = src.documentType
        this.originalname = src.originalname
        this.fileType = src.fileType
        this.md5 = src.md5
        if (this.isOfficeUrl) {
          this.config.documentType = this.documentType
          this.config.document.fileType = this.fileType
          this.config.document.key = this.md5
          this.config.document.title = this.originalname
          this.config.document.url = this.previewUrl
          this.config.events = {
            onError: this.destoryEditor(),
            onRequestClose: this.destoryEditor(),
          }
          if (this.isShuju || this.isAdmin) {
            this.config.document.permissions.copy = true
          }
        }
        this.$nextTick(() => {
          if (!this.docEditor && this.isOfficeUrl) {
            this.docEditor = new window.DocsAPI.DocEditor('testIframeCompanyOchat', this.config)
          }
        })
      } catch (error) {
        this.$message.error(`预览：${(error.response && error.response.message) || error.message}`)
      }
    },
    changeMenuStatus() {
      this.showSearch = !this.showSearch
    },
    updateTabName(name) {
      this.activeTabName = name
    },
    async uploadAtta() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
      const dom = this.$el.querySelector('.uploadAtta')
      if (dom) dom.click()
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.UploadDialog.visible()
      const res = response[0]
      try {
        const option = {
          createdAt: res.createdAt,
          fileId: res._id,
          md5: res.md5,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          type: '公司O-Chart',
          companyId: this.companyId,
        }
        await app.service('company').insertCompanyAtta(option)
        this.getCompanyFiles()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async uploadError(res) {
      console.log(res)
    },
    async getCompanyFiles() {
      const result = await app.service('company').getCompanyAtta(this.companyId)
      if (result.status === 'success') {
        this.companyFiles = result.data
          .filter(v => v.type === '公司O-Chart')
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
        if (this.companyFiles.length > 0) this.getFile(this.companyFiles[0])
      } else this.$message.error(result.msg)
    },
    // 附件删除
    async deleteCompanyAtta(value) {
      this.$confirm('此操作将删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const result = await app.service('company').deleteAtta(value._id)
          if (result.status === 200) {
            let index
            this.companyFiles.forEach((item, ind) => {
              if (item._id === value._id) index = ind
            })
            this.companyFiles.splice(index, 1)
            this.$message.success('删除成功!')
          } else this.$message.error(result.msg)
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    toEditTheStructure() {
      this.$refs.companyStructure &&
        this.$refs.companyStructure.open({ companyName: this.companyName, companyId: this.companyId })
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    close() {
      this.tree = []
      this.destoryEditor()
      this.clearSearch()
      this.departments = []
      this.$refs.companyOchartComponent && this.$refs.companyOchartComponent.initChartData()
    },
    refresh() {
      this.$refs.companyOchartComponent.loadData()
      this.getDepartments()
      this.toSearch()
    },
    showBulletin() {
      this.$refs.Bulletin.open()
    },
    modifyZIndex() {
      this.zIndex = app.root.dragindex++
    },
    getTree({ tree, nodes }) {
      this.tree = tree
      this.nodes = nodes
    },
    showDepartmentList(nodeData) {
      this.clearSearch()
      this.search.部门 = nodeData.inCompanyParentId === nodeData.公司 ? '' : nodeData.名称
      this.toSearch()
    },
    async getDepartments() {
      const res = await app.service('company').getDepartments(this.companyName)
      if (res.status === 'success') {
        const arr = res.data || []
        this.departments = [...new Set(arr)]
      } else this.$message.error(res.msg)
    },
    async open(obj = {}) {
      this.companyName = obj.companyName
      this.$refs.companyStructure && this.$refs.companyStructure.close()
      await this.getCompanyId()
      this.getCompanyFiles()
      this.fileTableHeight = document.documentElement.clientHeight - 220
      this.isShow = true
      this.tree = []
      this.getDepartments()
      if (this.activeTabName === '公司架构') this.toEditTheStructure()
      else {
        this.$nextTick(_ => {
          this.toSearch()
          this.$refs.companyOchartComponent.loadData(obj)
        })
      }
    },
    async getCompanyId() {
      const result = await app.service('company').checkCompanyAlias(this.companyName)
      if (result.status === 200) this.companyId = result.data.companyId
    },
    toSearch() {
      this.departmentName = this.search.部门
      const { companyName, departmentName, search } = this
      this.$refs.companyDepartmentList.open({ companyName, departmentName, search })
    },
    clearSearch() {
      for (const key in this.search) {
        if (Array.isArray(this.search[key])) this.search[key] = []
        else this.search[key] = ''
      }
      this.departmentName = ''
    },
  },
}
</script>
<style src="../../statistics/css/companyOchart.css" scoped></style>
